<template>
  <div>
    <h1>Show</h1>
    <div>
      <pre>{{ organizational_structure | pretty_json }}</pre>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState("organizational_structures", ["organizational_structure"]),
  },
  methods: {
    ...mapActions("organizational_structures", ["ActionShow"]),
  },
  async created() {
    await this.ActionShow({id: this.$route.params.id});
  },
};
</script>

<style>
</style>
